import { Component, Input, OnInit } from '@angular/core';
import { CustomerReview } from 'anchor-shared/lib/model/entity/customerReview';
import moment from 'moment';

@Component({
  selector: 'app-vessel-review',
  templateUrl: './vessel-review.component.html',
  styleUrls: ['./vessel-review.component.scss'],
})
export class VesselReviewComponent implements OnInit {
  @Input() cardView: boolean;
  @Input() vesselReview;
  @Input() displayPrivate;

  publicReview: CustomerReview;
  starRating: number[];
  customerJoinDate: string = '';
  rentalDate: string = '';
  displayFullReview: boolean = false;
  displayFullPrivateReview: boolean = false;
  truncatedCharLength: number;

  constructor() {}

  ngOnInit(): void {
    this.truncatedCharLength = this.cardView ? 180 : 250;

    this.customerJoinDate = moment(this.vesselReview.customerJoinDate).format(
      'MMMM YYYY',
    );
    this.rentalDate = moment(this.vesselReview.rentalDate).format('MMMM YYYY');

    const result = new Array(5).fill(0);
    for (let i = 0; i < this.vesselReview.rating; i++) {
      result[i] = 1;
    }
    this.starRating = result;
  }
}
